import { API_ENDPOINT } from "../constants";
import { DELETE, GET, PATCH, POST } from "./axiosClient";
const Order = {
  getProvinces: async (params) => {
    let res = await GET(API_ENDPOINT.GET_LIST_PROVINCES, params);
    return res;
  },

  getDistricts: async (params, data) => {
    let res = await GET(API_ENDPOINT.GET_LIST_DISTRICTS, params, data);
    return res;
  },
  getWards: async (params, data) => {
    let res = await GET(API_ENDPOINT.GET_LIST_WARDS, params, data);
    return res;
  },

  getPathogens: async (params) => {
    let res = await GET(API_ENDPOINT.GET_LIST_PATHOGENS, params);
    return res;
  },

  getVaccines: async (params) => {
    let res = await GET(API_ENDPOINT.GET_LIST_VACCINE, "", params);
    return res;
  },

  getLocationMedicines: async (params) => {
    let res = await GET(API_ENDPOINT.GET_LOCATION_MEDICINES, "", params);
    return res;
  },
  orderRegister: async (params) => {
    let res = await POST(API_ENDPOINT.ORDER_REGISTER, params);
    return res;
  },
  orderLogin: async (params) => {
    let res = await POST(API_ENDPOINT.ORDER_LOGIN, params);
    return res;
  },
  getInfoUser: async () => {
    let res = await GET(API_ENDPOINT.GET_INFO_USER);

    return res;
  },
  getOrderDetail: async (params) => {
    let res = await GET(API_ENDPOINT.GET_ORDER_DETAIL, "", params);

    return res;
  },
  getVaccineGroup: async (params) => {
    let res = await GET(API_ENDPOINT.GET_GROUP_AGE, params);
    return res;
  },
  cancelOrder: async (params) => {
    let res = await GET(API_ENDPOINT.CANCEL_REGISTER_ORDER, "", params);
    return res;
  },
  UserRegister: async (params) => {
    let res = await POST(API_ENDPOINT.USER_REGISTER, params);
    return res;
  },
  ResetPassword: async (params) => {
    let res = await POST(API_ENDPOINT.RESET_PASSWORD, params);
    return res;
  },
  ChangePassword: async (params) => {
    let res = await POST(API_ENDPOINT.CHANGE_PASSWORD, params);
    return res;
  },

  UpdateProfile: async (params) => {
    let res = await POST(API_ENDPOINT.USER_UPDATE, params);
    return res;
  },

  updateTimeOrder: async (params) => {
    let res = await POST(API_ENDPOINT.UPDATE_TIME_ORDER, params);
    return res;
  },

  logOutUser: async () => {
    await localStorage.removeItem("USER_TOKEN");
    await localStorage.removeItem("USER_ID");
    await localStorage.removeItem("AUTH_INFO");
    await localStorage.removeItem("INFO_LOGIN");
    await localStorage.removeItem("order");
  },
};

export default Order;
